import { CSSProperties, ReactNode, useEffect, useRef } from "react";

// import { ReactComponent as HomeSvg } from '@/assets/icons/home.svg';
import Typography from "../Typography";
import { CardTabWrapper } from "./style";

type Props = {
  title: string;
  count: number;
  img?: any;
  onClick?: () => void;
  enableBorder?: boolean;
  mainContentstyle?: CSSProperties;
  cardStyle?: CSSProperties;
  dropDownComponent?: ReactNode;
};

const CardTab = ({
  count,
  title,
  img,
  onClick,
  enableBorder = false,
  mainContentstyle,
  cardStyle,
  dropDownComponent,
}: Props) => {
  const displayCountRef = useRef(0);
  const countDisplayElement = useRef(null);

  useEffect(() => {
    const duration = 500;
    const startTime = performance.now();

    const animateCounter = (currentTime: number) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      displayCountRef.current = Math.floor(progress * count);

      if (countDisplayElement.current) {
        (countDisplayElement.current as HTMLSpanElement).textContent =
          displayCountRef.current.toString();
      }

      if (progress < 1) {
        requestAnimationFrame(animateCounter);
      }
    };

    requestAnimationFrame(animateCounter);
  }, [count]);

  const handleCardClick = () => {
    if (onClick) {
      onClick();
    }
  };
  const Icon = img;
  return (
    <CardTabWrapper
      onClick={handleCardClick}
      $enableBorder={enableBorder}
      style={{ ...cardStyle, border: enableBorder ? "1px solid #ccc" : "none" }}
    >
      {img && (
        <div
          style={{
            borderWidth: 3,
            borderRadius: 35,
            padding: 6,
            backgroundColor: "#D9E4F7",
            borderColor: "#F1EFFB",
            borderStyle: "solid",
          }}
        >
          <Icon fill="#0A56AF" height={20} width={20} />
        </div>
      )}
      <Typography
        size="normal"
        fontFamily="urbanist"
        style={{
          color: "#6D718B",
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>
      {dropDownComponent ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Typography
            fontWeight="semibold"
            fontFamily="roboto"
            color="dark.neutral_60"
            size="extraLargeHeading"
          >
            <span ref={countDisplayElement}>0</span>
          </Typography>
          {dropDownComponent}
        </div>
      ) : (
        <Typography
          fontWeight="bold"
          fontFamily="urbanist"
          color="dark.neutral_60"
          size="extraLargeHeading"
        >
          <span ref={countDisplayElement}>0</span>
        </Typography>
      )}
    </CardTabWrapper>
  );
};

export default CardTab;
